import React, { Component } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import ToggleSwitch from "./common/toggleSwitch";
import Table from "./common/table";

import auth from "../services/authService";

const $ = require("jquery");
$.DataTable = require("datatables.net");

class UsersTable extends Component {
  columns = [
    {
      path: "email",
      label: "Email",
      //content: user => <Link to={`/users/${user._id}`}>{user.phoneNumber}</Link>
    },
    { path: "name", label: "Full Name" },
    { path: "phoneNumber", label: "Phone" },
    {
      path: "balance",
      label: "Wallet Balance",
      content: (user) => `₦${user.balance}`,
    },
    {
      path: "isActive",
      label: "Status",
      content: (user) => (user.isActivated ? "activated" : "deactivated"),
    },
    {
      path: "signupDate",
      label: "Signup Date",
      content: (user) => moment(user.signupDate).startOf("day").format("LL"),
    },
    // {
    //   key: (user) => `${user._id}-a`,
    //   label: "isAdmin?",
    //   content: (user) => (
    //     <ToggleSwitch
    //       switched={user.isAdmin}
    //       handleChange={() => this.props.onRoleSwitch(user)}
    //     />
    //   ),
    // },
    {
      key: (user) => `${user._id}-s`,
      label: "Info",
      content: (user) => (
        <Link to={`/user/${user._id}`} className="btn btn-primary btn-sm">
          View
        </Link>
      ),
    },
  ];

  deleteColumn = {
    key: "delete",
    label: "Delete",
    content: (user) => (
      <button
        onClick={() => this.props.onDelete(user)}
        className="btn btn-danger btn-sm"
      >
        Delete
      </button>
    ),
  };

  constructor() {
    super();
    const user = auth.getCurrentUser();
    // if (user && user.isAdmin) {
    //   //this.columns.push(this.editColumn);
    //   this.columns.push(this.deleteColumn);
    // }
  }

  componentDidMount() {
    $(document).ready(function () {
      $("#dataTable").DataTable();
    });
  }

  render() {
    const { users, message } = this.props;
    return <Table columns={this.columns} data={users} message={message} />;
  }
}

export default UsersTable;
